<template>
  <div class="callme">
      <h2>联系我们</h2>
      <p>邮箱:2353434162@qq.com</p>
      <p>QQ:2353434162<span>加群</span></p>
      <div class="cancel">
        <span @click="$emit('close')">取消</span>
      </div>

  </div>
</template>

<script>
export default {
  name: 'callme'
}
</script>

<style scoped lang="less">
*{
  margin: 0;
  padding: 0;
}
.callme{
  width: 230px;
  height: 180px;
  background-color: #fefefe;
  padding: 30px  50px;
  h2 {
    font-size: 25px;
    text-align: center;
    color: #474747;
  }
  p {
    margin-top: 20px;
    font-size: 16px;
    color: #999;

    span {
      display: none;
      // width: 50px;
      height: 25px;
      margin-left: 10px;
      font-size: 20px;
      background-color: #18c1cf;
      color: #fff;
      border-radius: 8px;
    }
  }
  .cancel{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 37px;
    height: 50px;
    border-top: 1px solid #cfcfcf;
    color: #474747;
  }
}
</style>
